import {gql} from '@apollo/client'

export const GET_LOCATIONS = gql`
  query GetLocations {
    locations {
      nodes {
        id
        name
        addressLine1
        addressLine2
        city
        zipCode
        phone
        state {
          code
        }
        country {
          name
        }
        isDefault
        active
        allowFulfillment
      }
    }
  }
`

export const DELETE_LOCATION = gql`
  mutation DeleteLocation($id: UUID!) {
    deleteLocation(input: {id: $id}) {
      clientMutationId
    }
  }
`

export const UPDATE_DEFAULT_LOCATION = gql`
  mutation UpdateDefaultShippingLocation($id: UUID!) {
    updateDefaultShippingLocation(input: {pLocationId: $id}) {
      clientMutationId
    }
  }
`

export const GET_FULFILLMENT_LOCATION = gql`
  query FulfillmentLocations {
    fulfillmentLocations {
      nodes {
        orderType
        pickupLocationId
        shippingLocationId
        id
        isDefault
      }
    }
  }
`

export const UPDATE_FULFILLMENT_LOCATIONS = gql`
  mutation SaveFulfillmentLocation($fulfillmentLocations: [FulfillmentLocationInput]) {
    saveFulfillmentLocation(input: {pFulfillmentLocations: $fulfillmentLocations}) {
      clientMutationId
    }
  }
`

export const REMOVE_FULFILLMENT_LOCATIONS = gql`
  mutation RemoveFulfillmentLocations($ids: [UUID]!) {
    removeFulfillmentLocations(input: {ids: $ids}) {
      clientMutationId
    }
  }
`

export const CREATE_FULFILLMENT_LOCATIONS = gql`
  mutation CreateFulfillmentLocationRules(
    $fulfillmentLocations: [FulfillmentLocationInput]
    $setupId: UUID!
  ) {
    createFulfillmentLocationRules(input: {pFulfillmentLocations: $fulfillmentLocations}) {
      clientMutationId
    }
    updateStoreSetup(input: {patch: {orderLocation: true}, id: $setupId}) {
      clientMutationId
    }
  }
`
export const SAVE_MULTIPLE_FULFILLMENT_LOCATIONS = gql`
  mutation SaveMultipleFulfillmentLocations($locationIds: [UUID]!, $orderType: OrderTypes!) {
    saveMultipleFulfillmentLocations(input: {locationIds: $locationIds, pOrderType: $orderType}) {
      clientMutationId
    }
  }
`
